import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DateRange, MatCalendarCellClassFunction, MatDatepickerModule } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { RentActions } from 'src/app/common/store/actions/rent.actions';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { BookingStatus } from '../../constants/rent-basic-data';
import { Booking } from '../../models/booking.model';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';


@Component({
    selector: 'app-booking-edit',
    templateUrl: './booking-edit.component.html',
    styleUrl: './booking-edit.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatDatepickerModule, CdkOverlayOrigin]
})
export class BookingEditComponent {

  @Input() carId: string = "";
  @Input() currentBookings: Booking[] = [];
  @Input() objectSource: ObjectSource = ObjectSource.DEALER;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;

  showBookingAddNew: boolean = false;
  showBookingCalendar: boolean = false;

  selectedDateRange: DateRange<Date>;

  constructor(
    private router: Router,
    private store: Store) {

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.tomorrowDate.getDate()+1);
      this.yesterdayDate.setDate(this.yesterdayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);
    }

  onSelectedDateRangeChange(date: Date): void {
    if (
      this.selectedDateRange &&
      this.selectedDateRange.start &&
      date > this.selectedDateRange.start &&
      !this.selectedDateRange.end
    ) {
      this.selectedDateRange = new DateRange(
        this.selectedDateRange.start,
        date
      );
    } else {
      this.selectedDateRange = new DateRange(date, null);
    }

    //console.log(this.selectedDateRange.start?.toDateString());
    //console.log(this.selectedDateRange.end?.toDateString());
  }

  filterPastDates = (date: Date | null): boolean => {
    return (date! > this.yesterdayDate);
  }

  filterBookedDates = (date: Date): boolean => {

    let available: boolean = true;

    this.currentBookings.forEach(
      (booking: Booking) => {
        if (booking.endDate >= ""+date.valueOf() && ""+date.valueOf()  >= booking.startDate && booking.status != BookingStatus.CANCELLED) {
          available = false;
          return;
        }
      }
    );
    return available;;
  }

  filterPastDatesAndBookedDates = (date: Date): boolean => {

    let available: boolean = true;

    if ( ! (date > this.yesterdayDate) ) {
      return false;
    } 

    this.currentBookings.forEach(
      (booking: Booking) => {
        if ((booking.endDate >= ""+date.valueOf() && ""+date.valueOf()  >= booking.startDate) && booking.status != BookingStatus.CANCELLED) {
          available = false;
          return;
        }
      }
    );
    return available;
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      //const date = cellDate.getDate();

      // Highlight the 1st and 20th day of each month.
      return this.currentBookings.find( 
        (booking) => (booking.endDate >= ""+cellDate.valueOf() && ""+cellDate.valueOf()  >= booking.startDate) 
        ) ? 'booked-date' : '';
    }

    return '';
  };


  addNewBooking(): void{

    let booking: Booking = new Booking();

    booking.carId = this.carId;

    booking.startDate = this.selectedDateRange.start?.toISOString()!;
    booking.endDate = this.selectedDateRange.end?.toISOString()!;

    this.store.dispatch(RentActions.bookingNewSubmit ( { booking: booking, objectSource: this.objectSource}));
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
